import * as React from "react"

const SvgSave = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.857q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19.857v-14q0-.824.587-1.412A1.93 1.93 0 0 1 5 3.857h11.175a1.98 1.98 0 0 1 1.4.575l2.85 2.85a1.98 1.98 0 0 1 .575 1.4v11.175a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm14-13.15-2.85-2.85H5v14h14zm-7 10.15a2.9 2.9 0 0 0 2.125-.875A2.9 2.9 0 0 0 15 15.857q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 12.857q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 15.857q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875m-5-8h7q.424 0 .713-.287A.97.97 0 0 0 15 9.857v-2a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288H7a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712v2a.97.97 0 0 0 .287.713q.288.287.713.287" />
  </svg>
)
export default SvgSave
